export default "__VITE_ASSET__d68709d9__"